import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70e8cde6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "openRegistration" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "openRegistration__title" }, "ELIGE TU NIVEL", -1))
const _hoisted_3 = { class: "openRegistration__list" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "item__levelTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsLevel.levels, (level) => {
        return (_openBlock(), _createElementBlock("li", {
          key: level.name,
          class: "list__level"
        }, [
          _createVNode(_component_router_link, {
            to: `/classes/${level.route}`,
            class: "openRegistration__item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: level.image,
                alt: `imagen de ${level.name} group`,
                class: "item__image"
              }, null, 8, _hoisted_4),
              _createElementVNode("h3", _hoisted_5, _toDisplayString(level.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ])
  ]))
}